import React, { useState } from 'react'
import { HiMiniBars3 } from 'react-icons/hi2';
import { IoChevronDownOutline } from 'react-icons/io5';
import { categoriesTrigger } from '../lib/FakeData';
import { BiMinus, BiPlus } from 'react-icons/bi';
import { FaBarsStaggered } from 'react-icons/fa6';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const TriggerMenusButton = () => {
  const [open, setOpen] = useState(false);
  const [openChid, setOpenChild] = useState([]);
  let timeoutId;

  const handleMouseEnter = () => {
    clearTimeout(timeoutId);
    setOpen(true);
  };

  const handleMouseLeave = () => {
    // Delay 200ms trước khi ẩn menu
    timeoutId = setTimeout(() => setOpen(false), 200);
  };
  const toggleChild = (index) => {
    setOpenChild((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };
  const categoryList = useSelector((state) => state.categoryList);
  const { loading: loadingList, error: errorList, categories } = categoryList;
  // console.log("categoriescategories ",categories);
  
  return (
    <button className='bg-[--color-button-2] rounded-full lg:w-[90%] xl:w-[75%] flex h-[40px] items-center py-2 lg:px-3 xl:px-4 gap-2 font-bold group relative'   onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}>
      <FaBarsStaggered  className='mb-1 text-sm' />
      <span className='flex items-center text-sm'>Mua sắm theo danh mục</span>
      <IoChevronDownOutline className='mb-1' />
      <div className={`absolute z-50 w-full top-[calc(100%+20px)] left-0 bg-white p-4 rounded-lg border border-[--color-button-3]  opacity-0 translate-y-[-10px] 
       ${open ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2 pointer-events-none"}
      transition-all duration-300 ease-out `}>
        <ul className='flex flex-col items-start '>
          {categories?.map((value, index) => {
            return <li key={index} className={`flex flex-col w-full justify-center text-left font-normal text-sm border-t py-2 m-0`}>
              <Link to={`/category/${value?._id}`}>
              <div className='flex w-full justify-between'>{value.name}   {value.children && value.children.length > 0 && <button onClick={()=>toggleChild(index)}>
              {!openChid.includes(index) && <BiPlus/>}  
              {openChid.includes(index) && <BiMinus/>}  
                </button> }</div> 
              {value.children && value.children.length > 0 &&
                <ul className={`${openChid.includes(index)?"max-h-96 opacity-100 translate-y-0":"max-h-0 opacity-0 -translate-y-2"}  flex-col items-start mt-2 overflow-hidden transition-all duration-300 ease-in-out`}>
                  {value.children?.map((child, ichild) => {
                    return <li className={`flex flex-col w-full text-left font-normal justify-center pl-2 border-t py-2  m-0`} key={ichild}> {child.name} </li>
                  })}
                </ul>
              }
             </Link>
            </li>
            
          })}
        </ul>
      </div>
    </button>
  )
}
export default TriggerMenusButton;
